import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import StatsSection from '../components/StatsSection';
//import ProcessSection from '../components/ProcessSection';
import AboutSection from '../components/AboutSection';
import ServicesSlider from '../components/ServicesSlider';
import PricingSection from '../components/PricingSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import TestimonialsSlider from '../components/TestimonialsSlider';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';

const HomePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const openModal = (packageData = null) => {
    setSelectedPackage(packageData);
    setIsModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar onOpenModal={() => openModal()} />
      <HeroSection onOpenModal={() => openModal()} />
      <AboutSection onOpenModal={() => openModal()} />
       <PricingSection onOpenModal={openModal} />
      <StatsSection />
      {/* <ProcessSection /> */}
      
      <ServicesSlider onOpenModal={() => openModal()} />
     
      <WhyChooseUsSection />
      <TestimonialsSlider />
      <FAQSection />
      <Footer />
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} selectedPackage={selectedPackage} />
    </div>
  );
};

export default HomePage;
